__turbopack_context__.v({
  "root": "TextReveal-module__n_pkuq__root",
});
